export const WAIT_UNITS = [
    { key: 'minutes', factor: 1 },
    { key: 'hours', factor: 60 },
    { key: 'days', factor: 1440 },
];

export const splitWait = minutes => {
    const total = minutes || 0;
    const unit = total % 1440 === 0 ? WAIT_UNITS[2] : total % 60 === 0 ? WAIT_UNITS[1] : WAIT_UNITS[0];
    return { amount: total / unit.factor, unit };
};

export const formatWait = (t, minutes) => {
    if (!minutes) return t('AutomationsPage.nodes.setDuration');
    const { amount, unit } = splitWait(minutes);
    return `${amount} ${t(`AutomationsPage.units.${unit.key}`)}`;
};
